import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Journal } from '../classes/index';

@Injectable()
export class JournalService {

	constructor(private firestore: Firestore) {
		console.log('VoucherService initialization...');
	}

	listJournalTemplates(){
		return collectionData(collection(this.firestore, 'journal_templates'), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new Journal();
				object.fromJSON(data);
				return object;
			});
		}));
	}

	getJournalTemplate(journalId){
		return docData(doc(this.firestore, `journal_templates/${journalId}`))
		.pipe(map(team => {
			let obj = team as Journal;
			if(team){
				obj.id = journalId;
			}
			return obj;
		}));
	}

	getGameJournal(gameId){
		return collectionData(query(collection(this.firestore, 'journal_templates'), where('gameId', '==', gameId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new Journal();
				object.fromJSON(data);
				return object;
			});
		}));
	}
}
